import { Component, OnInit } from '@angular/core';
import {ApiService} from '../services/api.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as $ from "jquery";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  getUserProleList: any;
  userName: any;
  update:any;
  userId:any;
  showUserName: any;
  // userName:any;

  constructor(
    public ApiServiceCall: ApiService,
    private modalService: NgbModal
  ) { 
    this.getUserProleList = [];
    this.update = {};
    this.userId;
  }

  ngOnInit(): void {

    // this.userName = localStorage.getItem('userName');

    this.userProfileList();
    this.userId = localStorage.getItem("userID")
    this.userName = localStorage.getItem("userName");
    this.showUserName = this.userName.replace(/^"|"$/g, '');
  }
  userProfileList(){
    this.userName = localStorage.getItem('userName');
    var obj = {
      userId:localStorage.getItem("userID")
    }
    console.log("userProfile"+ JSON.stringify(obj));
    $('.loading-overlay').addClass('is-active');
    this.ApiServiceCall.userProfile(obj).subscribe(data => {
      $('.loading-overlay').removeClass('is-active');
      this.getUserProleList = data.responseValue;
      //  this.userName = data['name'];
    
      console.log("Sandeep Sir CT//----"+ JSON.stringify(this.getUserProleList));
      // console.log(this.userName);
  
    });
  }
  onUpdate(content2) {
    var obj = {
      userId:localStorage.getItem("userID")
    }
    $('.loading-overlay').addClass('is-active');
    this.ApiServiceCall.userProfile(obj).subscribe(data => {
      $('.loading-overlay').removeClass('is-active');
      this.update = data.responseValue[0];
      console.log("Vishnu CT//----"+ JSON.stringify(this.update));
    });
    
    this.modalService.open(content2);
  
  }

  onUpdateProfile(){
    var obj = {
      userId:this.userId,
      name:this.update.name,
      mobileNo:this.update.mobileNo,
      address:this.update.address,
    }
    console.log("multipleFile",obj);
    $('.loading-overlay').addClass('is-active');
    this.ApiServiceCall.updateProfile(obj).subscribe((data) =>{
      $('.loading-overlay').removeClass('is-active');
      alert(data.responseMessage);
    });
    this.modalService.dismissAll();
    this.userProfileList();
  }

}
